import { CommonResponse, TableRequestType, TableReponseType } from '@/types';
import { httpRequest } from '@/utils/request';

export interface CustomerDeviceBindRequest {
  customerId: string;
  deviceId: string;
}

export interface CustomerDeviceUnbindRequest {
  customerId: string;
  deviceId: string;
}

export interface CustomerDeviceQueryResponse {
  id: string;
  customerId: string;
  deviceId: string;
  deviceName: string;
  bindTime: number;
  status: number;
  created: number;
}

export function getCustomerDeviceList<T>(
  params: TableRequestType & {
    customerId?: string;
    deviceId?: string;
  },
) {
  return httpRequest<any, CommonResponse<TableReponseType<T>>>({
    url: '/api/v1/customer-devices',
    params,
  });
}

export function bindCustomerDevice(data: CustomerDeviceBindRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/customer-device/bind',
    method: 'post',
    data,
  });
}

export function unbindCustomerDevice(data: CustomerDeviceUnbindRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/customer-device/unbind',
    method: 'post',
    data,
  });
}

export interface ProviderDeviceBindRequest {
  providerId: string;
  deviceId: string;
  serviceType?: string;
}

export interface ProviderDeviceQueryResponse {
  id: string;
  providerId: string;
  deviceId: string;
  deviceName: string;
  serviceType: string;
  bindTime: number;
  status: number;
  created: number;
}

export function getProviderDeviceList<T>(
  params: TableRequestType & {
    providerId?: string;
    deviceId?: string;
  },
) {
  return httpRequest<any, CommonResponse<TableReponseType<T>>>({
    url: '/api/v1/provider-devices',
    params,
  });
}

export function bindProviderDevice(data: ProviderDeviceBindRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/provider-device/bind',
    method: 'post',
    data,
  });
}

// 客户服务商绑定
export interface CustomerProviderBindResponse {
  id: string;
  customerId: string;
  customer: string;
  providerId: string;
  provider: string;
  phone: string;
  deviceId: string;
  deviceName: string;
  bindTime: number;
  status: number;
}

export function getCustomerProviderBindList<T>(params: TableRequestType & { keyword?: string }) {
  return httpRequest<any, CommonResponse<TableReponseType<T>>>({
    url: '/api/v1/customer-provider-binds',
    params,
  });
}

export function unbindCustomerProvider(customerId: string, providerId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/customer-provider-bind',
    method: 'delete',
    params: { customerId, providerId },
  });
}

export interface CustomerProviderBindRequest {
  customerId: string;
  providerId: string;
}

export function bindCustomerProvider(data: CustomerProviderBindRequest) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/customer-provider-bind',
    method: 'post',
    data,
  });
}

// ==================== 滤芯价格管理 ====================

export interface FilterPriceItem {
  id: string;
  filterCode: string;
  filterName: string;
  monthlyFee: number;
  validDays: number;
  unit: string;
  status: number;
  sortOrder: number;
  remark: string;
  created: number;
}

export interface FilterPriceSaveParams {
  id?: string;
  filterCode: string;
  filterName: string;
  monthlyFee: number;
  validDays?: number;
  unit?: string;
  status?: number;
  sortOrder?: number;
  remark?: string;
}

export function getFilterPriceList() {
  return httpRequest<any, CommonResponse<FilterPriceItem[]>>({
    url: '/api/v1/filter-prices',
    method: 'get',
  });
}

export function saveFilterPrice(data: FilterPriceSaveParams) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/filter-price',
    method: 'post',
    data,
  });
}

export function deleteFilterPrice(id: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/filter-price/${id}`,
    method: 'delete',
  });
}
